import React, { useState } from "react";
import banner from "../Assets/Images/homebanner.jpg";
import ApiRequest from "../Common/restservice";
import { errorToast } from "../Common/showtoast";
import { Link, useNavigate } from "react-router-dom";

function Login() {
  const navigate = useNavigate();
  const [stateObj, setStateObj] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const OnLogin = async (e) => {
    e.preventDefault();
    if (!stateObj.username) {
      errorToast("Enter valid username or email");
      return;
    } else if (!stateObj.password) {
      errorToast("Enter valid password");
      return;
    }
    let jsoninput = {
      username: stateObj.username,
      password: stateObj.password,
    };
    let res = await ApiRequest(
      "MemberLogin.asp",
      "POST",
      JSON.stringify(jsoninput)
    );
    if (res.status === "error") {
      errorToast(res.message);
      return;
    }
    localStorage.setItem("token", res.token);
    localStorage.setItem("username", res.username);
    localStorage.setItem("usertype", res.usertype);
    localStorage.setItem("usertypecategory", res.usertypecategory);
    navigate("/");
  };

  return (
    <>
      <section>
        <div
          className="bannerimg cover-image bg-background3"
          data-bs-image-src={banner}
          style={{ background: `url(${banner}) center 25%` }}
        >
          <div className="header-text mb-0">
            <div className="container">
              <div className="text-center text-white">
                <h1>Login</h1>
                <ol className="breadcrumb text-center">
                  <li className="breadcrumb-item">
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li
                    className="breadcrumb-item active text-white"
                    aria-current="page"
                  >
                    Login
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sptb">
        <div className="container customerpage">
          <div className="row">
            <div className="single-page">
              <div className="col-lg-5 col-xl-4 col-md-6 d-block mx-auto">
                <div className="wrapper wrapper2">
                  <form className="card-body" onSubmit={OnLogin}>
                    <h3>Login</h3>

                    <div className="mail">
                      <input
                        type="text"
                        name="mail"
                        value={stateObj.username || ""}
                        onChange={(e) =>
                          setStateObj({ ...stateObj, username: e.target.value })
                        }
                      />
                      <label>Mail or Username</label>
                    </div>

                    <div className="passwd" style={{ position: "relative" }}>
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        value={stateObj.password || ""}
                        onChange={(e) =>
                          setStateObj({ ...stateObj, password: e.target.value })
                        }
                        style={{ paddingRight: "40px" }}
                      />
                      <label>Password</label>
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          padding: 0,
                          margin: 0,
                          color: "#333",
                          fontSize: "20px",
                          userSelect: "none",
                        }}
                        aria-label={showPassword ? "Hide password" : "Show password"}
                      >
                        {showPassword ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            viewBox="0 0 24 24"
                          >
                            <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
                            <circle cx="12" cy="12" r="3" />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            viewBox="0 0 24 24"
                          >
                            <path d="M17.94 17.94A10.21 10.21 0 0 1 12 19c-5 0-9.27-3.11-11-7 1.08-2.06 2.8-3.79 4.73-4.85" />
                            <path d="M1 1l22 22" />
                            <path d="M10.58 10.58a3 3 0 0 0 4.24 4.24" />
                            <path d="M14.12 14.12L9.88 9.88" />
                          </svg>
                        )}
                      </button>
                    </div>

                    <div className="submit">
                      <button className="btn btn-primary btn-block" type="submit">
                        Login
                      </button>
                    </div>

                    <p className="mb-2">
                      <Link to={"/forgotpassword"}>Forgot Password</Link>
                    </p>

                    <p className="text-dark mb-0">
                      Don't have account?
                      <Link to={"/register"} className="text-primary mx-1">
                        Sign UP
                      </Link>
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Login;
